<template>
  <div class="country-code-picker">
    <span class="eva eva-chevron-down" style="font-size:1.4em"></span>
    <div class="placeholder">{{countries[value].emoji}} +{{countries[value].phone}}</div>
    <select :value="value" @input="onInput">
      <option
        v-for="(country, code) in countries"
        :value="code"
      >{{code}} +{{country.phone}} {{country.emoji}}
      </option>
    </select>
  </div>
</template>

<script>

  export default {
    name: 'ViCountryCodePicker',
    props: {
      value: {
        type: String,
        default: 'US'
      },
      countries: {
        type: Object
      },
    },

    methods: {
      onInput(e) {
        this.$emit('input', e.target.value)
      }
    },
  }
</script>

<style lang="scss">
  @font-face {
    font-family: 'Flags';
    src: url("../assets/fonts/BabelStoneFlags.ttf");
    font-weight: normal;
    font-variant: normal;
  }

  .country-code-picker {
    position: relative;
    color: #000000;
    height: 100%;
    font-family: -apple-system, BlinkMacSystemFont, 'Flags', sans-serif;
    display: flex;
    align-items: center;

    .placeholder {
      display: flex;
      padding: 6px 5px 6px 0;
      font-size: 14px;
      align-items: center;
      line-height: 1;
      white-space: nowrap;
    }

    select {
      -webkit-appearance: none;
      font-size: 16px;
      opacity: 0;
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
    }
  }
</style>
